import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RelatedArticles = ({ articles, onArticleClick }) => {
  return (
    <div>
      <h3 className="text-xl font-bold mb-6 text-white flex items-center gap-2">
        <Icon name="TrendingUp" size={24} color="#14b8a6" />
        Trending Articles
      </h3>
      <div className="space-y-4">
        {articles?.map((article, index) => (
          <motion.div
            key={article?.id}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => onArticleClick(article)}
            className="group cursor-pointer bg-slate-800/30 hover:bg-slate-800/60 rounded-xl p-4 border border-teal-500/10 hover:border-teal-500/40 transition-all duration-300"
          >
            <div className="flex gap-4">
              <div className="relative w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                <Image
                  src={article?.image}
                  alt={article?.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-xs text-teal-400 font-semibold mb-1 block">{article?.category}</span>
                <h4 className="text-sm font-bold text-white line-clamp-2 mb-2 group-hover:text-teal-400 transition-colors">
                  {article?.title}
                </h4>
                <div className="flex items-center gap-3 text-xs text-slate-400">
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={12} color="currentColor" />
                    <span>{article?.readTime} min</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Eye" size={12} color="currentColor" />
                    <span>{article?.views}</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RelatedArticles;